import { createClient } from '@supabase/supabase-js';
import { supabaseUrl, supabaseAnonKey } from '@/lib/constants';

// Create a single supabase client for interacting with your database
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
  },
});

/*
// Create a bucket for organization logos if it doesn't exist
try {
  supabase.storage
    .createBucket("organizations", {
      public: true,
      fileSizeLimit: 5242880, // 5MB
      allowedMimeTypes: [
        "image/png",
        "image/jpeg",
        "image/gif",
        "image/webp",
        "image/svg+xml",
      ],
    })
    .then(({ error }) => {
      if (error && error.message !== "Bucket already exists") {
        console.error("Error creating organizations bucket:", error);
      }
    })
    .catch((err) => {
      console.error("Failed to create bucket:", err);
    });
} catch (error) {
  console.error("Error initializing storage bucket:", error);
}
*/
